import { useCallback, useState, useEffect, useRef } from "react";
import { UseMenuPlacementProps, UseMenuPlacementReturn } from "../interfaces";

export const useMenuPlacement = (
  props: UseMenuPlacementProps,
): UseMenuPlacementReturn => {
  const { isMultiSelect = false, margin = 40, menuListHeight = 190 } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [menuPlacement, setMenuPlacement] = useState<"top" | "bottom">(
    "bottom",
  );

  const calculateMenuPlacement = useCallback(() => {
    if (!containerRef.current) return "bottom";

    const rect = containerRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const totalMenuHeight = isMultiSelect
      ? menuListHeight + 44
      : menuListHeight;

    const spaceBelow = viewportHeight - rect.bottom - margin;
    const spaceAbove = rect.top - margin;

    if (spaceBelow < totalMenuHeight) {
      if (spaceAbove >= totalMenuHeight) return "top";
      return "bottom";
    }

    return "bottom";
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      const calculatedPlacement = calculateMenuPlacement();
      setMenuPlacement(calculatedPlacement);
    }
  }, [isMenuOpen, calculateMenuPlacement]);

  return {
    containerRef,
    menuPlacement,
    setIsMenuOpen,
  };
};
